import { IManifest } from 'm3u8-parser';

import { TDecryptPosition } from '@streamLoader/PlaylistDecrypt/IPlaylistDecryptStage';

export abstract class PlaylistValidatorDecryptStage {
  public readonly pipelinePosition: TDecryptPosition | undefined;

  abstract validateScheme(data: string | IManifest, activeScheme: string | null, activeKey: string | null): boolean;
}
